import React from 'react';
import { Fragment, useState, useEffect } from 'react';
import { Row, Alert, Col } from 'react-bootstrap';
import FormBusca from './form_busca';
import ContasService from '../../services/obras'
import Obra from './obra';
import Moment from 'moment';

const ListarObras = () => {

    Moment.locale('pt');
    Moment.updateLocale('pt', {
        months: [
            "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho",
            "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"
        ]
    });

    const [obras, setObras] = useState([]);
    const [vazio, setVazio] = useState(false);

    async function fetchObras() {
        const response = await ContasService.listar();
        if (response.data.length >= 1) {
            setObras(response.data)
            setVazio(false)
        } else {
            setObras([])
            setVazio(true)
        }
    }

    useEffect(() => {
        fetchObras();
    }, []);

    return (
        <Fragment>
            <Fragment>
                <FormBusca
                    setObras={setObras}
                    setVazio={setVazio}
                    fetchObras={fetchObras}
                    obras={obras}
                />
            </Fragment>

            {vazio ? <Fragment>
                <Alert variant='danger'>Sua busca não gerou nenhum resultado :(</Alert>
            </Fragment> :
                <Fragment>
                    <h4>Obras no Município</h4>
                    <Row xs={2}>
                        {obras.map((obr, index) =>
                            <Obra
                                obr={obr}
                                key={index}
                            />
                        )}
                    </Row>
                </Fragment>}
        </Fragment>

    )
}

export default ListarObras;